import { useState, useEffect } from "react";
import { Box, ClickAwayListener } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { SxProps } from "@mui/system";
import { useTranslation } from "react-i18next";
import { getCmDocsById } from "../../../services/CmService";
import UserCmDoc from "../../../entities/UserCMDoc";
import { useDispatch, useSelector } from "react-redux";
import { CmConstants } from "../../../utils/constants/CmConstants";
import { setCurrentActiveTab } from "../../../state/actions/LettersReportsActions";
import { useHistory } from "react-router-dom";
import useWindowDimensions from "../../../customHooks/useWindowDimensions";
import { screenSzie } from "../../../utils/main";

import ActionItem from "./ActionItem/ActionItem";
import HeaderActionItemProps from "./HeaderActionsItemProps";

import "./HeaderActionsItem.scss";
import { setModalChild, setModalState } from "../../../state/actions/modalAction";
import DepositPopUpComponent from "../../DepositPopUp/DepositPopUp.component";
import HeaderDepositPopUpComponent from "../../DepositPopUp/HeaderDepositPopUp.component";
import { checkRedemptionPath } from "../../../services/CheckRedemptionPath";
import { checkBankAccountPath, CheckBankAccountPathCallVU } from "../../../services/CheckBankAccountPath";
import { Get101ButtonIsAllowed } from "../../../services/Get101ButtonIsAllowed";
import { Get101UrlPath } from "../../../services/Get101UrlPath";
import { GetTofesZikna } from "../../../services/TofesZikna";
import ErrorPopup from "../../ErrorPopup/ErrorPopup";
import DepositRequestPopUp from "../../DepositPopUp/DepositRequestPopUp.component";
import React from "react";


const HeaderActionsItem = (props: HeaderActionItemProps) => {
    const { t } = useTranslation("common");
    const dispatch = useDispatch();
    const history = useHistory();
    const [imageSrc, setImageSrc] = useState(props.image);
    const [open, setOpen] = useState<boolean>(false);
    const { firstName, userFunds, isAmit, isPensioner, userId, pensionTypeDesc, haveYearlyReportsred,is101ButtonAllowed  } = useSelector(
        (state: any) => state.UserReducer
    );
    const {isDoc } = useSelector(
        (state: any) => state.DashboardReducer
      );
      
  const { width } = useWindowDimensions();
  const isTablet = (width < screenSzie.tabletxl);


    //For getDepositMoney
    const { activeFund } = useSelector((state: any) => state.DashboardReducer);
    const [interactiveFormPath, setInteractiveFormPath] = useState<any>();
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [showLoading101, setShowLoading101] = useState<boolean>(false);
    const [showLoadingBank, setShowLoadingBank] = useState<boolean>(false);
    const [showLoadingZikna, setShowLoadingZikna] = useState<boolean>(false);
    const [isPensionReceiver, setisPensionReceiver] = useState<boolean>(false);


    const showErrorDeposit = (request: any) => {
        dispatch(setModalState(true));
        dispatch(
            setModalChild(
                // {interactiveFormPath: null, errorMessage: '', errorCode: 0}
                // <DepositPopUpComponent interactiveFormPath={{interactiveFormPath: null, errorMessage: '', errorCode: 85403}} center={true} size="m"/>
                <DepositPopUpComponent
                    interactiveFormPath={request}
                    center={true}
                    size="m"
                    isFromupdateBankAccount={request?.isFromupdateBankAccount != null ? request?.isFromupdateBankAccount : false}

                />
            )
        );
    };

    const showDepositMoney = (request: any) => {
        dispatch(setModalState(true));
        dispatch(
          setModalChild(
            <DepositRequestPopUp
              items={request}
              center={true}
              size="m"
            />
          )
        );
      };




    // const showErrorDeposit = (request: any) => {
    //     dispatch(setModalState(true));
    //     dispatch(
    //         setModalChild(
    //             // {interactiveFormPath: null, errorMessage: '', errorCode: 0}
    //             // <DepositPopUpComponent interactiveFormPath={{interactiveFormPath: null, errorMessage: '', errorCode: 85403}} center={true} size="m"/>
    //             <DepositPopUpComponent interactiveFormPath={request} center={true} size="m"/>

    //         )
    //     );
    // }

    React.useEffect(() => {
        var count = 0;
        for(var i=0;i<userFunds.length;i++){
            count += userFunds[i].isPensioner ? 1 : 0;    
        }
        setisPensionReceiver(count == 1 ? true : false);
      },[userFunds])

    const mouseEnterHandler = () => {
        setImageSrc(props.greenImage);
    };
    const mouseLeaveHandler = () => {
        setImageSrc(props.image);
    };

    const handleClick = () => {
        setOpen((prev) => !prev);
    };

    const handleClickAway = (e: any) => {
        isTablet ? setTimeout(() => setOpen(false), 1) : setOpen(false);
    };

    const goToReports = () => {
        handleClick()
        dispatch(setCurrentActiveTab(t("LettersReports.TabLabel5")));
        history.push({
            pathname: '/reports',
            state: {  // location state
                tabVal: t("LettersReports.TabLabel5"), 
            },
        });
    };

    const goToTlushiPension = () => {
        dispatch(setCurrentActiveTab(t("LettersReports.TabLabel2")));
        history.push({
          pathname: '/reports',
          state: {  // location state
              tabVal: t("LettersReports.TabLabel2"), 
          },
        }); 
      };

    const goToMasConfirms = () => {
        handleClick()
        dispatch(setCurrentActiveTab(t("LettersReports.TabLabel6")));
        history.push({
            pathname: '/reports',
            state: {  // location state
                tabVal: t("LettersReports.TabLabel6"), 
            },
          }); 
    };

    const goTo106Docs = () => {
        handleClick()
        dispatch(setCurrentActiveTab(t("LettersReports.TabLabel4")));
        history.push({
            pathname: '/reports',
            state: {  // location state
                tabVal: t("LettersReports.TabLabel4"), 
            },
          }); 
    };

    const fill101 = async () => {
        setShowLoading101(true)
        const response = await Get101UrlPath();        
            if (response?.form101Path) {                
                window.open(encodeURI(response?.form101Path), '_blank')
                setTimeout(() => {
                    setShowLoading101(false)
                }, 5000);
            } else {
                setShowLoading101(false)
                dispatch(setModalState(true));
                dispatch(
                  setModalChild(
                    <ErrorPopup size="m" label={t("general.error")} center={true} />
                  )
                );         
            }        
      };


    const getUpdateBank = async () => {
        setShowLoadingBank(true);
        const response = await CheckBankAccountPathCallVU(Number(activeFund.fundCode))
        setInteractiveFormPath(response);
        setTimeout(() => {
            setShowLoadingBank(false);
        }, 5000);
        if (response?.interactiveFormPath) {
            window.open(encodeURI(response?.interactiveFormPath), '_blank')
        } else {
            showErrorDeposit(response)
        }
    }

    const getDepositMoney = async () => {
        await setShowLoading(true);
        const response = await checkRedemptionPath(0);
        await setShowLoading(false);   
        if (response.array_CheckRedemptionPath !== null) {
          const res = await response.array_CheckRedemptionPath.map((item:any)=>{return {
            "calculatedRedemption":item.calculatedRedemption,
            "title":userFunds.filter((userFund:any)=> {return (userFund.fundCode ==  item.fundCode) &&  userFund.fundLabel}),
            "interactiveFormPath":item.interactiveFormPath,
            "msg":item.msg,
            "fundCode": item.fundCode,
          }})
          return showDepositMoney(res)
        } else {
          return showErrorDeposit(response);
        }
      };

      const openPensionerRequest = () => {
        setShowLoadingZikna(true);
        GetTofesZikna(sessionStorage.getItem("fundCode")?.toString()).then((res)=>{
        setShowLoadingZikna(false);
           if(res){
             window.open(res);
           }else {
             dispatch(setModalState(true));
             dispatch(
               setModalChild(
                <ErrorPopup size="m" label={t("Sidebar.ziknaError")} isContactLink={true} subLabel=" " center={true} />
            )
             );          
           }
         })     
      };  

    const styles: SxProps = {
        position: "absolute",
        top: 116,
        zIndex: 1,
        bgcolor: "#FFF",
        borderRadius: "20px",
        boxShadow:
            "0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)",
        width: "290px",
        border: "1px solid #cfd1d5",
    };

    return (
        <div>
        <ClickAwayListener onClickAway={handleClickAway}>
            <Box
                
                tabIndex={0}
                style={{ position: "relative", display: "flex", alignItems: "center" }}
                className="desktop-flex"
                role="button"
                aria-expanded={open ? "true" : "false"}
            >
                <div
                    className="header-center-item actions-btn-he"
                    onMouseEnter={mouseEnterHandler}
                    onMouseLeave={mouseLeaveHandler}
                    onClick={handleClick}
                >
                    <img
                        className="header-center-icon"
                        src={imageSrc}
                        width={24}
                        height={24}
                        alt=""
                    />
                    <div>
                        <span className="header-center-text">{props.text}</span>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </div>
                </div>
            
            </Box>
        </ClickAwayListener>
        {open ? (
                    <Box sx={styles}>
                        {(activeFund.isAmit) ? (
                            <ActionItem
                                onClick={goToReports}
                                imgSrcPath="file-icon.png"
                                alt="file-icon"
                                text={t("Sidebar.reports")}
                            />
                        ) : null}

                        {activeFund.isPensioner ? (
                            <ActionItem
                                onClick={goToTlushiPension}
                                imgSrcPath="file-icon.png"
                                alt="file-icon"
                                text={t("Sidebar.tlushiPension")}
                            />
                        ) : null}

                        {activeFund.isAmit || (activeFund.isPensioner && (haveYearlyReportsred)) ?
                            <ActionItem
                                onClick={goToMasConfirms}
                                imgSrcPath="file-icon.png"
                                alt="file-icon"
                                text={t("Sidebar.masConfirms")}
                            />
                            : null}


                        {/* PRTC-221 activeFund.isPensioner && userFunds.length == 1*/
                        isPensionReceiver  ? (
                            <>
                                <ActionItem
                                    imgSrcPath="file-icon.png"
                                    alt="file-icon"
                                    text={t("Sidebar.updateBankAccount")}
                                    loading={showLoadingBank}
                                    onClick={getUpdateBank}
                                />
                                {/* Part B */}
                            </>
                        ) : null}

                        {activeFund?.isAmit ? (
                            <>
                                <ActionItem
                                    imgSrcPath="money-icon.png"
                                    alt="money-icon"
                                    text={t("Sidebar.depositRequest")}
                                    loading={showLoading}
                                    onClick={getDepositMoney}
                                />
                                <ActionItem
                                    onClick={openPensionerRequest}
                                    imgSrcPath="pensioner-icon.png"
                                    alt="pensioner-icon"
                                    loading={showLoadingZikna}
                                    text={t("Sidebar.ziknaRequest")}
                            />
                                {/* Part B */}
                            </>
                        ) : (
                            <>
                         
                              {is101ButtonAllowed ?
                               <ActionItem
                               onClick={fill101}
                               loading={showLoading101}
                               imgSrcPath="file101.png"
                               alt="file101Icon"
                               text={t("Sidebar.fill101")}
                              /> : null
                                }
                                {/* Part B */}
                                {activeFund.isPensioner ? (
                                    <ActionItem
                                        onClick={goTo106Docs}
                                        imgSrcPath="file106.png"
                                        alt="file106Icon"
                                        text={t("Sidebar.106Doc")}
                                    />
                                ) : null}
                            </>
                        )}

                    </Box>
                ) : null}
        </div>
    );
};

export default HeaderActionsItem;
